<script setup lang="ts">
import { postWindowBridge } from '@/utils/windowBridge'

const router = useRouter()
useHead({
  title: '',
})
function sendGooHome() {
  router.go(-1)
}

onMounted(() => {
  postWindowBridge('toggleCloseButton', false)
  postWindowBridge('toggleTopButton', false)
  postWindowBridge('toggleShareButton', false)
  postWindowBridge('toggleBottomBar', true)
  postWindowBridge('setAppBarTitle', '')
  postWindowBridge('toggleFavoriteButton', false)
})
</script>
<template>
  <div class="error-contents">
    <div class="error-message">
      正常に処理できませんでした。<br />再度お試しください。
    </div>
    <div class="btn-area">
      <button class="rounded button" @click="sendGooHome()">
        <a>前のページへ戻る</a>
      </button>
    </div>
  </div>
</template>

<style scoped>
.button {
  color: #ffffff;
  height: 44px;
  font-weight: bold;
  background-color: #df2020;
  border: none;
  width: 100%;
  margin-top: 68px;
}

.btn-area {
  margin-left: 16px;
  margin-right: 16px;
}

.error-contents {
  text-align: center;
  margin-top: 68px;
}

.error-message {
  font-size: 16px;
  font-family: 'Hiragino Kaku Gothic Pro';
  margin-left: 31px;
  margin-right: 31px;
}
</style>
